import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createNotification,
  getNotification,
  getNotifications,
} from "../../../services/NotificationServices/NotificationServices";

export const initialState = {
  loading: false,
  notifications: [],
  notification: {},
  error: null,
};

export const getAllNotifications = createAsyncThunk(
  "notif/getAllNotifications",
  async () => {
    try {
      const data = await getNotifications();
      return data;
    } catch (ex) {
      console.log(ex);
    }
  }
);

export const addNewNotification = createAsyncThunk(
  "notif/addNewNotification",
  async (initialData, thunkAPI) => {
    try {
      const { status, data } = await createNotification(initialData);
      if (status >= 200) {
        window.location.replace("/notification");
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (ex) {
      // Return backend error payload when available (e.g., { detail: 'Your "email" is not verified.' })
      const payload = ex?.response?.data ?? ex?.message;
      return thunkAPI.rejectWithValue(payload);
    }
  }
);

export const getNotificationByTitle = createAsyncThunk(
  "notif/getNotificationByTitle",
  async (title) => {
    try {
      const { data } = await getNotification(title);
      return data;
    } catch (ex) {
      console.log(ex);
    }
  }
);

export const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllNotifications.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.notifications = payload;
      });
    builder
      .addCase(getNotificationByTitle.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotificationByTitle.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.notification = payload;
      })
      .addCase(addNewNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewNotification.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addNewNotification.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = payload ?? error;
      });
  },
});

export default notificationSlice.reducer;
